import RoadmapItem_Minimal from './RoadmapItem_Minimal'

export default {
    RoadmapItem_Minimal,
}
